import { HubDeploymentStatus } from '@robovision/hub'
import {
  type DataTag,
  queryOptions,
} from '@tanstack/vue-query'
import { Inference } from '~domain/inference/Inference'
import { hubApi } from '~services/api'
import { RETHROW_ERROR_AFTER_HANDLING } from '~utils/api/error-handling'


export type InferenceFilter = `status:${HubDeploymentStatus}`

type UntypedQuery = Parameters<typeof hubApi.deployments.listDeployments>[0]
type Query = UntypedQuery & {
  filter?: InferenceFilter[]
}

interface InferencesResponse {
  count?: number
  items: Inference[]
}

function createFetchInferencesQueryKey (query?: Query) {
  const key = ['hubApi', 'deployments', 'listDeployments'] as unknown[]
  if (query) {
    key.push(query)
  }
  return key as DataTag<unknown[], InferencesResponse>
}

async function fetchInferences (query?: Query): Promise<InferencesResponse> {
  const {
    data: {
      count,
      items,
    },
  } = await hubApi.deployments.listDeployments(query, RETHROW_ERROR_AFTER_HANDLING)
  return {
    count,
    items: items.map(Inference.fromResponse),
  }
}

export function fetchInferencesQueryOptions (query?: Query) {
  return queryOptions({
    queryFn: () => fetchInferences(query),
    queryKey: createFetchInferencesQueryKey(query),
  })
}
